import leftArrow from "../../assets/left.svg";

export default function LeftArrow() {
  return <img src={leftArrow} alt="left-arrow" />;
}
